// Tailwind classes for the file list buttons in the PDF viewer sidebars
export const FILE_ITEM_CLASS =
  'bg-gray-100 border-gray-200 text-gray-800 hover:bg-gray-200 active:bg-gray-300 ' +
  'dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100 dark:hover:bg-gray-600 dark:active:bg-gray-500'

// Persistent highlight for the file currently shown in the viewer
export const SELECTED_FILE_ITEM_CLASS =
  'bg-blue-600 border-blue-700 text-white font-semibold shadow-sm hover:bg-blue-700 active:bg-blue-800'
